import { classNamesFor } from '../../../utils/classNames';

const factory = classNamesFor('Slider');

export const sliderClassNames = {
  root: factory.root(),
  /** Applied when the value is a two-thumb range (2-tuple) */
  range: factory.attribute('range'),
  disabled: factory.globalClassNames.disabled,
};
